import React, { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import HiOutlineMail from '@meronex/icons/hi/HiOutlineMail';
import { useData } from '../../LoginModal/data';
import { getConfig } from '../../../utils/config';
import GrClose from '@meronex/icons/gr/GrClose';
import SignUp from '../SignUp';
import BiPhone from '@meronex/icons/bi/BiPhone';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { AccountRestorationModal } from '@reloy/shared-components';
import { winnreNoAuth } from '../../../utils/axios';
import { isCkpc } from '../../../helpers';

function LoginForm({ closeLoginModal }) {
    const [termsCheckbox, setTermsCheckbox] = useState(false);
    const [selectedOption, setSelectedOption] = useState('CHANNEL_PARTNER');
    const [showRestoreModal, setShowRestoreModal] = useState(false);
    const [restoreLoading, setRestoreLoading] = useState(false);
    const [restoreError, setRestoreError] = useState('');
    const [showPhoneInfo, setShowPhoneInfo] = useState(false);

    // const config = getConfig();
    const history = useHistory();
    const config = getConfig();
    const onValueChange = (e) => {
        setIsOtpSent(false);
        setSelectedOption(e.target.value);
    };

    const {
        state: {
            mobileNumberIsValid,
            mobile,
            mobileHasError,
            sendOtpLoading,
            OTP,
            OTPHasError,
            OTPIsValid,
            loginLoading,
            email,
            emailHasError,
            emailIsValid,
            alertMessage,
            showSuccessAlert,
            showErrorAlert,
            isInternationalCustomer,
            createRegistration,
            isOtpSent,
            timeLeftToResend,
            loginWithEmail
        },
        onChange,
        validator,
        setIsOtpSent,
        setIsTouched,
        getOTP,
        setInputFocused,
        authenticateHandler,
        OTPChangedHandler,
        OTPBlurHandler,
        emailBlurHandler,
        emailChangedHandler,
        setShowErrorAlert,
        setShowSuccessAlert,
        setAlertMessage,
        setCreateRegistration,
        resetEmail,
        getMobileWithoutCountryCode,
        setMobile,
        setIsInternationalCustomer,
        setLoginWithEmail
    } = useData(selectedOption);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSuccessAlert(false);
            setShowErrorAlert(false);
        }, 3000);

        return () => {
            clearTimeout(timer);
            // setAlertMessage(null);
        };
    }, [showSuccessAlert, showErrorAlert]);

    useEffect(() => {
        if (config?.isInternationalcp) {
            setIsInternationalCustomer(true);
            setLoginWithEmail(true);
        }
    }, [])

    useEffect(() => {
        if (selectedOption == 'Site Visitor') {
            setLoginWithEmail(false);
        }
    }, [selectedOption]);

    const backHandler = () => {
        resetEmail();
        setMobile('+91');
        setIsInternationalCustomer(false);
        setIsTouched(false);
        setTermsCheckbox(false);
        setCreateRegistration(false);
        setIsOtpSent(false);
    };

    const handleOnChange = () => {
        setTermsCheckbox(!termsCheckbox);
    };

    return (
        <>
            {createRegistration ? (
                <>
                    <SignUp
                        setAlertMessage={setAlertMessage}
                        setShowErrorAlert={setShowErrorAlert}
                        setShowSuccessAlert={setShowSuccessAlert}
                        emailIsValid={emailIsValid}
                        email={email}
                        emailBlurHandler={emailBlurHandler}
                        emailHasError={emailHasError}
                        emailChangedHandler={emailChangedHandler}
                        backHandler={backHandler}
                        closeLoginModal={closeLoginModal}
                        isInternationalCustomer={isInternationalCustomer}
                        selectedOption={selectedOption}
                        createRegistration={createRegistration}
                        loginWithEmail={loginWithEmail}
                    />
                </>
            ) : (
                <div className="">
                    <div className={`flex  px-8 pb-2 justify-between`}>
                        <h1
                            className={`self-center text-lg md:text-2xl font-semibold ${config?.loginModal.text} `}
                        >
                            Login
                        </h1>
                        <GrClose
                            onClick={closeLoginModal}
                            className={`self-center h-4 w-4 cursor-pointer ${config?.loginModal.text}`}
                        />
                    </div>

                    <div className="px-8 pb-4 ">
                        {/* <p className="block text-sm md:text-base tracking-wide self-centre text-gray-600 ">
                            Select your role{' '}
                        </p> */}
                        <div className="flex gap-y-2 flex-wrap md:flex-row gap-x-2 mt-2">
                            <button
                                value="CHANNEL_PARTNER"
                                onClick={(e) => onValueChange(e)}
                                className={`py-2 px-3 ${selectedOption == 'CHANNEL_PARTNER'
                                        ? 'bg-primary text-white'
                                        : 'border-2 border-primary'
                                    }  rounded`}
                            >
                                {config?.name === 'Godrej' ? 'Influencer' : 'Channel Partner'}
                            </button>
                            {window.reloy_env?.client_config?.LOGIN
                                ?.SHOW_GUEST && (
                                    <button
                                        value="Site_Visitor"
                                        onClick={(e) => onValueChange(e)}
                                        className={`py-2 px-3 ${selectedOption == 'Site_Visitor'
                                                ? 'bg-primary text-white'
                                                : 'border-2 border-primary'
                                            }  rounded`}
                                    >
                                        Guest
                                    </button>
                                )}
                            {/* {config?.loginModal?.showEmployeeLogin && (
                                <button
                                    value="Employee"
                                    onClick={(e) => onValueChange(e)}
                                    className={`py-2 px-3 ${
                                        selectedOption == 'Employee'
                                            ? 'bg-primary text-white'
                                            : 'border-2 border-gray-200'
                                    }  rounded`}
                                >
                                    Employee
                                </button>
                            )} */}
                            {/* {config?.loginModal?.showSVLogin && (
                                <button
                                    value="Site Visitor"
                                    onClick={(e) => onValueChange(e)}
                                    className={`py-2 px-3 ${
                                        selectedOption == 'Site Visitor'
                                            ? 'bg-primary text-white'
                                            : 'border-2 border-gray-200'
                                    }  rounded`}
                                >
                                    Site Visitor
                                </button>
                            )} */}
                        </div>
                    </div>

                    <div className="px-8 ">
                        <form className="w-full">
                            {selectedOption !== 'Employee' &&
                                !loginWithEmail && (
                                    <div
                                        className={` w-full flex flex-col mx-auto ${selectedOption === 'CHANNEL_PARTNER'
                                                ? 'mb-2'
                                                : 'mb-2'
                                            }  relative`}
                                    >
                                        <div className="relative flex items-center justify-between mb-1">
                                            <label className="block font-semibold text-sm md:text-base tracking-wide self-centre text-gray-600 ">
                                                Phone number
                                            </label>
                                            {isCkpc() && (
                                                <div
                                                    onMouseEnter={() => setShowPhoneInfo(true)}
                                                    onMouseLeave={() => setShowPhoneInfo(false)}
                                                    onFocus={() => setShowPhoneInfo(true)}
                                                    onBlur={() => setShowPhoneInfo(false)}
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Escape') {
                                                            setShowPhoneInfo(false);
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        aria-label="Phone number registration information"
                                                        aria-describedby={showPhoneInfo ? 'login-phone-info' : undefined}
                                                        className="relative flex items-center justify-center w-6 h-6 rounded-full border border-gray-300 bg-gray-50 text-primary text-xs font-semibold hover:bg-gray-100 hover:border-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                                                    >
                                                        i
                                                    </button>
                                                    {showPhoneInfo && (
                                                        <div
                                                            className="absolute bottom-full z-50 pb-3"
                                                            style={{ width: '320px', maxWidth: '100%', right: '-12px' }}
                                                        >
                                                            <div
                                                                id="login-phone-info"
                                                                role="tooltip"
                                                                className="relative rounded-xl border border-gray-200 bg-white p-4 text-sm leading-relaxed text-left text-gray-600 shadow-xl"
                                                            >
                                                                <p>
                                                                    <strong className="block mb-1 font-semibold text-gray-900">Already registered?</strong>
                                                                    Log in using your registered mobile number.
                                                                </p>
                                                                <p className="mt-3 pt-3 border-t border-gray-100">
                                                                    <strong className="block mb-1 font-semibold text-gray-900">New Channel Partner?</strong>
                                                                    Register on the app using your mobile number linked to your Aadhaar or PAN card.
                                                                </p>
                                                                <svg
                                                                    aria-hidden="true"
                                                                    focusable="false"
                                                                    width="18"
                                                                    height="10"
                                                                    viewBox="0 0 18 10"
                                                                    className="absolute text-gray-200"
                                                                    style={{ bottom: '-9px', right: '14px' }}
                                                                >
                                                                    <path d="M0 0H18L9 9Z" fill="white" />
                                                                    <path d="M0 0L9 9L18 0" fill="none" stroke="currentColor" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <PhoneInput
                                            disabled={isOtpSent}
                                            country="in"
                                            countryCodeEditable={false}
                                            containerClass={
                                                'peer py-3 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full  h-12 placeholder-transparent'
                                            }
                                            containerStyle={{
                                                width: '100%',
                                                border: '2px solid grey !important',
                                                outline: 'none'
                                            }}
                                            buttonStyle={{
                                                backgroundColor: 'white',
                                                border: 'none'
                                            }}
                                            inputStyle={{
                                                width: '100%',
                                                height: 'auto',
                                                border: 'none',
                                                outline: 'none',
                                                paddingLeft: '44px',
                                                fontSize: '16px'
                                            }}
                                            isValid={validator}
                                            onChange={onChange}
                                            // value={mobile}
                                            placeholder="Phone"
                                            enableSearch
                                            onBlur={() => {
                                                setIsTouched(true);
                                                setInputFocused(false);
                                            }}
                                            onFocus={() =>
                                                setInputFocused(true)
                                            }
                                            inputClass="border border-gray-300"
                                        />
                                        {mobileHasError && (
                                            <p
                                                className={` text-left text-sm mt-1 font-Roboto text-red-400`}
                                            >
                                                Please enter a valid number
                                            </p>
                                        )}
                                    </div>
                                )}
                            {(isInternationalCustomer ||
                                selectedOption === 'Employee' ||
                                loginWithEmail) && (
                                    <div
                                        class={`${selectedOption === 'CHANNEL_PARTNER'
                                                ? 'mb-2'
                                                : 'mb-2 md:mb-2'
                                            }  relative`}
                                    >
                                        <input
                                            type="email"
                                            id="email"
                                            class="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                            placeholder="name@example.com"
                                            onChange={emailChangedHandler}
                                            onBlur={emailBlurHandler}
                                            value={email}
                                            disabled={isOtpSent}
                                            autoComplete="off"
                                        />
                                        <label
                                            for="email"
                                            class="peer-placeholder-shown:opacity-100  opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                                        >
                                            {selectedOption === 'Employee'
                                                ? 'Company Email Address'
                                                : 'Email address'}
                                        </label>
                                        {emailHasError && (
                                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                                Please enter a valid email address
                                            </p>
                                        )}
                                    </div>
                                )}
                            <div className="flex my-3">
                                <input
                                    disabled={isOtpSent}
                                    type="checkbox"
                                    checked={termsCheckbox}
                                    onChange={handleOnChange}
                                    className="checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600"
                                    autoComplete="off"
                                />
                                <p className={` mx-2 text-sm `}>
                                    I agree to the
                                    <span
                                        onClick={() => {
                                            history.push(
                                                '/terms-and-conditions?login=true'
                                            );
                                            closeLoginModal();
                                        }}
                                        className="font-semibold text-primary cursor-pointer"
                                    >
                                        {` Terms & Conditions`}
                                    </span>
                                </p>
                            </div>
                            <button
                                className={`w-full  ${config?.loginModal.buttonBg} text-white p-2 md:p-3 rounded-md disabled:hover:text-white disabled:opacity-90 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:cursor-not-allowed`}
                                disabled={
                                    // showEmail
                                    //     ? !mobileNumberIsValid || !emailIsValid
                                    //     : !mobileNumberIsValid || sendOtpLoading
                                    isOtpSent
                                        ? !isOtpSent
                                        : selectedOption === 'Employee'
                                            ? !emailIsValid ||
                                            sendOtpLoading ||
                                            !termsCheckbox
                                            : isInternationalCustomer
                                                ?
                                                !emailIsValid ||
                                                sendOtpLoading ||
                                                !termsCheckbox
                                                : loginWithEmail
                                                    ? !emailIsValid ||
                                                    !termsCheckbox ||
                                                    sendOtpLoading
                                                    : !mobileNumberIsValid ||
                                                    sendOtpLoading ||
                                                    !termsCheckbox
                                }
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isOtpSent) {
                                        setIsOtpSent(false);
                                    } else {
                                        getOTP();
                                    }
                                }}
                                type={isOtpSent ? 'button' : 'submit'}
                            >
                                {isOtpSent
                                    ? `Use Another ${selectedOption === 'Employee' ||
                                        isInternationalCustomer ||
                                        loginWithEmail
                                        ? 'Email'
                                        : 'Mobile Number'
                                    }`
                                    : loginWithEmail ||
                                        selectedOption === 'Employee' ||
                                        isInternationalCustomer
                                        ? 'Get OTP on Mail'
                                        : 'Get OTP on Phone'}
                            </button>

                            {isOtpSent && (
                                <>
                                    <p className="mb-2 mt-2 opacity-75">
                                        OTP sent to{' '}
                                        <b>
                                            {selectedOption === 'Employee' ||
                                                isInternationalCustomer ||
                                                loginWithEmail
                                                ? email
                                                : mobile?.substr(2)}
                                        </b>
                                    </p>
                                    <div
                                        class={`${selectedOption === 'Customer'
                                                ? 'mb-2'
                                                : 'mb-2 md:mb-2'
                                            } relative`}
                                    >
                                        <input
                                            type="text"
                                            id="otp"
                                            class="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                            placeholder="password"
                                            onChange={OTPChangedHandler}
                                            onBlur={OTPBlurHandler}
                                            value={OTP}
                                            autoComplete="off"
                                        />
                                        <label
                                            for="password"
                                            class="peer-placeholder-shown:opacity-100   opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                                        >
                                            OTP
                                        </label>
                                        {OTPHasError && (
                                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                                {`Please enter a valid OTP`}
                                            </p>
                                        )}
                                    </div>

                                    <p className="opacity-75 mb-2 text-sm">
                                        Didn't Receive OTP?{' '}
                                        {timeLeftToResend > 0 ? (
                                            <b>
                                                Request Again in 00:
                                                {timeLeftToResend < 10
                                                    ? '0' + timeLeftToResend
                                                    : timeLeftToResend}
                                            </b>
                                        ) : (
                                            <b
                                                className="opacity-75 link"
                                                onClick={getOTP}
                                            >
                                                Request Again
                                            </b>
                                        )}
                                    </p>
                                    <button
                                        type={!isOtpSent ? 'button' : 'submit'}
                                        disabled={!OTPIsValid || loginLoading}
                                        onClick={authenticateHandler}
                                        class={`w-full bg-primary text-white p-2 md:p-3 rounded-md mb-3 disabled:opacity-90 disabled:bg-gray-400 disabled:cursor-not-allowed`}
                                    >
                                        Log in
                                    </button>
                                </>
                            )}
                            {selectedOption == 'CHANNEL_PARTNER' &&
                                !isOtpSent && !config?.isInternationalcp && (
                                    <>
                                        {' '}
                                        <h3 className="w-full text-center border-b-[1px] border-gray-300 mt-4 mb-4 leading-[0.1em]">
                                            <span className="px-1 bg-white text-gray-400">
                                                or
                                            </span>
                                        </h3>
                                        <button
                                            className={`flex items-center justify-center mt-5  w-full border-[2px] border-primary text-primary p-2 md:p-3 rounded-md  `}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLoginWithEmail(
                                                    (prev) => !prev
                                                );
                                            }}
                                            type={
                                                isOtpSent ? 'button' : 'submit'
                                            }
                                        >
                                            {loginWithEmail ? (
                                                <BiPhone className="h-6 w-6 mr-1" />
                                            ) : (
                                                <HiOutlineMail className="h-6 w-6 mr-1" />
                                            )}
                                            {loginWithEmail
                                                ? 'Continue with Mobile Number'
                                                : 'Continue with Email'}
                                        </button>
                                    </>
                                )}
                        </form>
                    </div>
                </div>
            )}
            {showSuccessAlert && (
                <div class="alert alert-success  mx-8 animate-pulse  h-auto mt-2">
                    <label>{alertMessage}</label>
                </div>
            )}
            {showErrorAlert && (
                <div class="alert alert-error mx-8 animate-pulse h-auto mt-2 flex-col items-start">
                    <label>{alertMessage}</label>
                    {(alertMessage?.toLowerCase().includes('pending deletion') ||
                        alertMessage?.toLowerCase().includes('restore') ||
                        alertMessage?.toLowerCase().includes('de-activated') ||
                        alertMessage?.toLowerCase().includes('deactivated')) && (
                            <button
                                type="button"
                                onClick={() => setShowRestoreModal(true)}
                                className="mt-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-md shadow-sm border border-blue-700 cursor-pointer self-start transition-all"
                            >
                                Restore Account
                            </button>
                        )}
                </div>
            )}
            {/*    <button
                onClick={() => {
                    closeLoginModal();
                    history.push('/contact-us?loginissue=true');
                }}
                className={`text-black w-full text-center pt-3 text-sm `}
            >
                Having trouble logging in?
            </button> */}
            <AccountRestorationModal
                open={showRestoreModal}
                onClose={() => {
                    setShowRestoreModal(false);
                    setRestoreError('');
                }}
                initialIdentifier={(typeof getMobileWithoutCountryCode === 'function' ? getMobileWithoutCountryCode() : (mobile && mobile !== '+91' && mobile !== '91' ? mobile : '')) || email || ''}
                onRequestCancelOtp={async (identifier) => {
                    setRestoreLoading(true);
                    setRestoreError('');
                    try {
                        const res = await winnreNoAuth.post(`/winnre/no-auth/account-closure/request-cancel-otp?requestUuid=${encodeURIComponent(identifier)}`);
                        if (res?.status === 'FAILED') {
                            throw new Error(res.message || 'Failed to send restore OTP');
                        }
                    } catch (err) {
                        setRestoreError(err.message || 'Failed to send restore OTP');
                        throw err;
                    } finally {
                        setRestoreLoading(false);
                    }
                }}
                onConfirmRestore={async (identifier, otp) => {
                    setRestoreLoading(true);
                    setRestoreError('');
                    try {
                        const res = await winnreNoAuth.post('/winnre/no-auth/account-closure/cancel', {
                            requestUuid: identifier,
                            otp
                        });
                        if (res?.status === 'FAILED') {
                            throw new Error(res.message || 'Failed to restore account');
                        }
                    } catch (err) {
                        setRestoreError(err.message || 'Failed to restore account');
                        throw err;
                    } finally {
                        setRestoreLoading(false);
                    }
                }}
                onSuccess={() => {
                    setShowRestoreModal(false);
                    closeLoginModal();
                }}
                requestOtpLoading={restoreLoading}
                confirmLoading={restoreLoading}
                errorMessage={restoreError}
            />
        </>
    );
}

export default LoginForm;
